const API_BASE_URL = process.env.REACT_APP_BASE_API_URL

export const loginUser = async (email, password ) => {

    try {
        
        const response = await fetch(`${API_BASE_URL}/common/auth/login`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email,
            password: password,
          }),
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          console.error(errorData);
          throw errorData

      }

        const data = await response.json();
        return data
      } catch (error) {
        console.error("Ошибка сети или сервера:", error.message);
        console.log(error)
        throw error

      }

}